import type {
  InventoryListingConfig,
  InventoryListingConfigKeys,
  possibleValueTypes
} from "@dealer-center/ddc-pages-inventory-config-interface";

export interface getDifferencesBetweenConfigsReturn {
  config: keyof InventoryListingConfig;
  oldValue: possibleValueTypes;
  newValue: possibleValueTypes;
}
export const getDifferencesBetweenConfigs = (
  existingConfig?: InventoryListingConfig,
  curentConfig?: InventoryListingConfig
): getDifferencesBetweenConfigsReturn[] => {
  if (!existingConfig || !curentConfig) return [];
  const returnValue: getDifferencesBetweenConfigsReturn[] = [];
  Object.keys(existingConfig).forEach(key => {
    const oldValue = existingConfig[
      key as InventoryListingConfigKeys
    ] as possibleValueTypes;
    const newValue = curentConfig[
      key as InventoryListingConfigKeys
    ] as possibleValueTypes;

    if (areValuesEqual(newValue, oldValue)) return;
    returnValue.push({
      config: key as InventoryListingConfigKeys,
      oldValue,
      newValue
    });
  });
  return returnValue;
};
function areValuesEqual(
  newValue: possibleValueTypes,
  oldValue: possibleValueTypes
) {
  if (typeof newValue === "object" && typeof oldValue === "object") {
    return JSON.stringify(newValue) === JSON.stringify(oldValue);
  }
  return newValue === oldValue;
}
